"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrowserPlatform = exports.getCurrentPlatform = exports.getWebViewPlatform = exports.isMobilePlatform = exports.isWebViewPlatform = exports.isIosWebView = exports.isAndroidWebView = exports.isInstagramInAppBrowser = exports.isFacebookInAppBrowser = exports.Platform = void 0;
var Platform;
(function (Platform) {
    Platform["ANDROID"] = "ANDROID";
    Platform["IOS"] = "IOS";
    Platform["WEB"] = "WEB";
    Platform["HYBRID"] = "HYBRID";
})(Platform || (exports.Platform = Platform = {}));
const hasNavigator = () => typeof navigator !== 'undefined';
const isFacebookInAppBrowser = () => {
    if (!hasNavigator()) {
        return false;
    }
    return /FB_IAB|FB4A|FBAV/i.test(navigator.userAgent);
};
exports.isFacebookInAppBrowser = isFacebookInAppBrowser;
const isInstagramInAppBrowser = () => {
    if (!hasNavigator()) {
        return false;
    }
    return /Instagram/i.test(navigator.userAgent);
};
exports.isInstagramInAppBrowser = isInstagramInAppBrowser;
const isInAppBrowser = () => (0, exports.isFacebookInAppBrowser)() || (0, exports.isInstagramInAppBrowser)();
const isAndroidWebView = () => {
    if (!hasNavigator()) {
        return false;
    }
    // This code is used to detect if the app running in an inAppBrowser. It is a workaround.
    if (isInAppBrowser()) {
        return false;
    }
    return /ok.webview\/Android/i.test(navigator.userAgent) || /\/Android/i.test(navigator.userAgent);
};
exports.isAndroidWebView = isAndroidWebView;
const isIosWebView = () => {
    if (!hasNavigator()) {
        return false;
    }
    // This code is used to detect if the app running in an inAppBrowser. It is a workaround.
    if (isInAppBrowser()) {
        return false;
    }
    return /ok.webview\/iOS/i.test(navigator.userAgent);
};
exports.isIosWebView = isIosWebView;
/** to detect IOS from mobile's or ipad's browser */
const isiOSBrowser = () => {
    if (!hasNavigator()) {
        return false;
    }
    // MacIntel is used to detect for iPad os > 13
    return /iPad|iPhone|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
};
/** to detect android from mobile's or tablet's browser */
const isAndroidBrowser = () => {
    if (!hasNavigator()) {
        return false;
    }
    return /android/i.test(navigator.userAgent);
};
// isHybrid
const isWebViewPlatform = () => {
    // This code is used to detect if the app running in an inAppBrowser. It is a workaround.
    if (isInAppBrowser()) {
        return false;
    }
    // -- workaround end
    return (0, exports.isAndroidWebView)() || (0, exports.isIosWebView)();
};
exports.isWebViewPlatform = isWebViewPlatform;
const isMobilePlatform = () => (0, exports.isWebViewPlatform)() || isAndroidBrowser() || isiOSBrowser();
exports.isMobilePlatform = isMobilePlatform;
const getWebViewPlatform = () => {
    if ((0, exports.isAndroidWebView)()) {
        return Platform.ANDROID;
    }
    if ((0, exports.isIosWebView)()) {
        return Platform.IOS;
    }
    return Platform.WEB;
};
exports.getWebViewPlatform = getWebViewPlatform;
const getCurrentPlatform = () => {
    if ((0, exports.isWebViewPlatform)()) {
        return Platform.HYBRID;
    }
    return Platform.WEB;
};
exports.getCurrentPlatform = getCurrentPlatform;
const getBrowserPlatform = () => {
    if (isAndroidBrowser()) {
        return Platform.ANDROID;
    }
    if (isiOSBrowser()) {
        return Platform.IOS;
    }
    return Platform.WEB;
};
exports.getBrowserPlatform = getBrowserPlatform;
//# sourceMappingURL=platform.js.map